import { Nowrap } from '@farmersdog/corgi-x';

export const characteristics = [
  {
    title: 'No fillers.',
    description: (
      <>
        Made with whole ingredients: what you see is{' '}
        <Nowrap>what you get.</Nowrap>
      </>
    ),
  },
  {
    title: 'Not ultra processed.',
    description: (
      <>
        Gently cooked: preserves <Nowrap>vital nutrients.</Nowrap>
      </>
    ),
  },
  {
    title: 'Not feed grade.',
    description: (
      <>
        Human-grade: the same <Nowrap>standards as your food.</Nowrap>
      </>
    ),
  },
  {
    title: 'Not one-size-fits-all.',
    description: (
      <>Personalized plans: easy portioning for weight management.</>
    ),
  },
];
